import {
  OPEN_MODAL,
  CLOSE_MODAL,
  TOGGLE_MODAL,
  CLOSE_MODALS,
} from '../actions/modalActions';

export default function (state = {}, action) {
  const { type, scope } = action;
  switch (type) {
    case OPEN_MODAL:
      return { ...state, [`${scope}ModalIsOpen`]: true };
    case CLOSE_MODAL:
      return { ...state, [`${scope}ModalIsOpen`]: false };
    case TOGGLE_MODAL:
      return { ...state, [`${scope}ModalIsOpen`]: !(state[`${scope}ModalIsOpen`]) };
    case CLOSE_MODALS:
      return {};
    default:
      return state;
  }
}
